import actions from '../../store/actions'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { DeleteMenuEntryRequest, DeleteMenuEntryResponse } from '../../resources/establishment/types'
import { useDispatch } from '../redux'

export const useDeleteMenuEntry = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const deleteMenuEntry = (payload: DeleteMenuEntryRequest): Promise<DeleteMenuEntryResponse> => {
        setInProgress(true)
        return mutations
            .deleteMenuEntry(payload)
            .then((response) => {
                setInProgress(false)
                dispatch(actions.deleteMenuEntry(response))
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        deleteMenuEntry,
        inProgress,
    }
}
